import { LOGGED_OUT } from 'actions/types';
import { GET_SWITCHING_QUOTES_SUCCESS } from 'actions/types/switching';
export const START_MONEVO_ONBOARDING = 'START_MONEVO_ONBOARDING';
export const SET_MONEVO_DETAILS = 'SET_MONEVO_DETAILS';
export const SEED_MONEVO_ONBOARDING = 'SEED_MONEVO_ONBOARDING';
export const CLEAR_MONEVO_ONBOARDING = 'CLEAR_MONEVO_ONBOARDING';
const initialState = {};
const monevoOnboarding = (state = initialState, action) => {
    switch (action.type) {
        // Reset flow
        case START_MONEVO_ONBOARDING: {
            return { ...initialState, ...action.payload };
        }
        case SET_MONEVO_DETAILS: {
            return { ...state, ...action.payload };
        }
        /**
         * Prefill from the backend. User edits before request arrives will not be lost
         */
        case SEED_MONEVO_ONBOARDING: {
            const seed = { ...action.payload };
            Object.keys(seed).forEach((key) => {
                if (state[key] !== undefined)
                    delete seed[key];
            });
            return { ...state, ...seed };
        }
        case CLEAR_MONEVO_ONBOARDING:
        case GET_SWITCHING_QUOTES_SUCCESS:
        case LOGGED_OUT: {
            return initialState;
        }
        default:
            return state;
    }
};
export default monevoOnboarding;
export const startMonevoOnboarding = (payload) => ({
    type: START_MONEVO_ONBOARDING,
    payload,
});
export const setMonevoDetails = (payload) => ({
    type: SET_MONEVO_DETAILS,
    payload,
});
export const setMonevoPreviousAddress = (addressId) => setMonevoDetails({
    selectedPreviousAddressId: addressId,
    noPreviousAddress: false,
});
export const setMonevoNoPreviousAddress = () => setMonevoDetails({
    selectedPreviousAddressId: undefined,
    noPreviousAddress: true,
});
export const seedMonevoOnboarding = (payload) => ({
    type: SEED_MONEVO_ONBOARDING,
    payload,
});
export const clearMonevoOnboarding = () => ({
    type: CLEAR_MONEVO_ONBOARDING,
});
